import { Component } from "react";
import { withStore } from "store/storeHandler";

class AppUpdateCheckpoint extends Component {
  constructor(props) {
    super(props);

    const { needUpdateApp } = props;
    if (needUpdateApp) {
      this.state.needLoadingDisplay = true;
    }
  }

  state = {
    needLoadingDisplay: false
  };

  render() {
    const { children } = this.props;
    const { needLoadingDisplay } = this.state;
    return needLoadingDisplay ? null : children;
  }

  componentDidMount() {
    const { needLoadingDisplay } = this.state;
    if (needLoadingDisplay) {
      window.location.replace(window.location.href);
    }
  }
}

export default withStore({
  stateMap: { appUpdate: ["needUpdateApp"] }
})(AppUpdateCheckpoint);
